import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import { ProtectedRoute } from '@/components/layout/ProtectedRoute';

const FilesPage = lazy(() => import('./FilesPage'));

export const filesRoutes: RouteObject[] = [
  {
    path: 'files',
    element: (
      <ProtectedRoute action="files:view">
        <FilesPage />
      </ProtectedRoute>
    ),
  },
];
